export const onValueChanged = <T>(
    value: T,
    prevValue: T | undefined,
    callback: () => void
): void => {
    if (prevValue !== undefined && value !== prevValue) {
        callback();
    }
};

export const getValueOrCallbackIfDiffer = <T>(
    values: T[],
    callback: () => T
): T => {
    if (values.length === 0) {
        return callback();
    }
    
    const first = values[0];
    const allEqual = values.every(value => value === first);

    return allEqual ? first : callback();
};
